const lateInits = [];

/**
 * @callback NowAndLaterCallback
 * @param {NodeList} elements
 * @return void
 */

/**
 * @param {string} selector
 * @param {NowAndLaterCallback} callback
 */
export default function nowAndLater(selector, callback)
{
    const nodes = document.querySelectorAll(selector);
    const id = Date.now() + '_' + lateInits.length;
    const wrappedCallback = (nodes) => {
        nodes.forEach(node => {
            node.dataset['nowAndLater' + id] = '';
        });
        callback(nodes);
    };
    if (nodes.length > 0) {
        wrappedCallback(nodes);
    }
    lateInits.push({selector: selector, callback: wrappedCallback, id: id});
}

const observer = new MutationObserver(function (mutationsList)
{
    for (const mutation of mutationsList) {
        for (const addedNode of mutation.addedNodes) {
            for (const lateInit of lateInits) {
                if (addedNode.querySelector === undefined) { // lets filter out text and comment nodes
                    continue;
                }
                const selector = lateInit.selector + ':not([data-now-and-later' + lateInit.id + '])';
                // If the added node matches itself, it will not be found by querySelectorAll, so we have to check first
                if (addedNode.matches(selector)) {
                    lateInit.callback([addedNode]);
                }
                // NOTE: the added not selector prevents double calls
                const nodes = addedNode.querySelectorAll(selector);
                if (nodes.length > 0) {
                    lateInit.callback(nodes);
                }
            }
        }
    }
});

observer.observe(document.documentElement, {childList: true, subtree: true});
